import apiClient from './client.jsx';
import { 
  dummyGetUsersApi, 
  dummyGetUserDetailApi, 
  dummyCreateUserApi, 
  dummyUpdateUserApi, 
  dummyGetUserPublicKeyApi 
} from './dummyUserApi.jsx';

const API_BASE = '/api/users';

// 개발 모드 설정 (환경 변수로 제어)
const USE_DUMMY_DATA = process.env.REACT_APP_USE_DUMMY_USER_API === 'true';

// 관리자 목록 조회
export const getUsersApi = async (filters = {}) => {
  if (USE_DUMMY_DATA) {
    return await dummyGetUsersApi(filters);
  }
  
  const { page = 0, size = 10, sortField = 'createdAt', direction = 'desc', ...otherFilters } = filters;

  const params = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
    sort: `${sortField},${direction}`,
    ...Object.fromEntries(
      Object.entries(otherFilters).filter(([_, value]) => value !== '' && value != null)
    )
  });

  const response = await apiClient.get(`${API_BASE}?${params.toString()}`);
  return response.data;
};

// 관리자 생성
export const createUserApi = async (userData) => {
  if (USE_DUMMY_DATA) {
    return await dummyCreateUserApi(userData);
  }
  
  const headers = {};
  if (userData.keyId) {
    headers['Key-Id'] = userData.keyId;
  }

  const requestData = {
    signInId: userData.signInId,
    name: userData.name,
    phone: userData.phone,
    email: userData.email,
    password: userData.password,
  };

  const response = await apiClient.post(API_BASE, requestData, { headers });
  return response.data;
};

// 관리자 상세 조회
export const getUserDetailApi = async (userId) => {
  if (USE_DUMMY_DATA) {
    return await dummyGetUserDetailApi(userId);
  }
  
  const response = await apiClient.get(`${API_BASE}/${userId}`);
  return response.data;
};

// 관리자 정보 수정
export const updateUserApi = async (userId, userData) => {
  if (USE_DUMMY_DATA) {
    return await dummyUpdateUserApi(userId, userData);
  }
  
  const headers = {};
  if (userData.keyId) {
    headers['Key-Id'] = userData.keyId;
  }

  const requestData = {
    signInId: userId,
    name: userData.name,
    phone: userData.phone,
    email: userData.email,
    password: userData.password,
  };

  const response = await apiClient.put(`${API_BASE}/${userId}`, requestData, { headers });
  return response.data;
};

// RSA 암호화를 위한 공개키 조회
export const getUserPublicKeyApi = async (keyId) => {
  if (USE_DUMMY_DATA) {
    return await dummyGetUserPublicKeyApi(keyId);
  }
  
  const response = await apiClient.get(`${API_BASE}/key/${keyId}`);
  return response.data;
};

// 관리자 삭제 (논리 삭제) - 백엔드 API가 없는 경우 비활성화 또는 다른 방법 사용
export const deleteUsersApi = async (userIds) => {
  // 현재 백엔드에 삭제 API가 없으므로 에러를 던지거나 비활성화 처리
  throw new Error('관리자 삭제 기능은 아직 지원되지 않습니다.');
  
  // const response = await apiClient.delete(API_BASE, {
  //   data: userIds,
  //   headers: {
  //     'Content-Type': 'application/json',
  //   }
  // });
  // return response.data;
};
